import { render, staticRenderFns } from "./AppointmentsCoordinatedEvaluations.vue?vue&type=template&id=0bab6282&"
import script from "./AppointmentsCoordinatedEvaluations.vue?vue&type=script&lang=js&"
export * from "./AppointmentsCoordinatedEvaluations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports